module.exports = __webpack_public_path__ + "img/transporter-undefined.79503c75.png";